module.exports = __webpack_public_path__ + "img/sngls.46a5ee72.svg";